import { render } from "./UserBioCard.vue?vue&type=template&id=0455d7c6"
import script from "./UserBioCard.vue?vue&type=script&lang=js"
export * from "./UserBioCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__